import { Popover } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';

import AppointmentPreview from 'FRONTEND/components/Calendar/AppointmentPreview';
import AvailabilityPreview from 'FRONTEND/components/Calendar/AvailabilityPreview';
import { CANCEL_REASON } from 'FRONTEND/components/Calendar/CalendarPopover/closeReasons';

const CalendarPopover = ({
  rtcServerUrl,
  calendarEvent = {},
  anchorEl,
  onClose = () => {},
}) => {
  const isOpen = Boolean(anchorEl);
  const isOnRightSide = dayjs(calendarEvent.startDate).day() === 1;
  const isOnTopSide = dayjs(calendarEvent.startDate).hour() >= 17;
  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={() => onClose(CANCEL_REASON)}
      disableScrollLock
      anchorOrigin={{
        vertical: isOnTopSide ? 'top' : 'center',
        horizontal: isOnRightSide ? 'right' : 'left',
      }}
      transformOrigin={{
        vertical: isOnTopSide ? 'bottom' : 'center',
        horizontal: isOnRightSide ? 'left' : 'right',
      }}
      PaperProps={{ sx: { borderRadius: '32px' } }}
    >
      {calendarEvent.appointmentId ? (
        <AppointmentPreview
          appointment={calendarEvent}
          onClose={onClose}
          rtcServerUrl={rtcServerUrl}
        />
      ) : calendarEvent.availabilityId && (
        <AvailabilityPreview
          availability={calendarEvent}
          onClose={onClose}
        />
      )}
    </Popover>
  );
};

export default CalendarPopover;
